module.exports = __webpack_public_path__ + "static/img/indexTopBg2.d9913033.png";